import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowBottomLeftIcon = createIconComponent(
  'ArrowBottomLeftIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 4L4 20M4 20V9M4 20H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
